import {PlainDtoModel} from '../../../../common/entity/dto/plain/plainDto.model';
import {ReportModel} from '../../../../reporting/report/api/entity/report.model';
import {ExamFormSummaryModel} from '../../../../exam-form/api/model/examFormSummary.model';
import {WithReportEntity} from '../../../../reporting/report/api/entity/withReport.entity';
import {IWithPermissionModel} from '../../../../common/permission/api/entity/iWithPermission.model';
import {PermissionsModel} from '../../../../common/entity/permissions.model';
import {TreatmentSummaryModel} from '../../../treatment/common/api/model/treatmentSummary.model';
import {ConsultationSummaryModel} from '../../../consultation/consultation/api/model/consultationSummary.model';

export class MedicalReportModel implements PlainDtoModel, WithReportEntity, IWithPermissionModel {
    id: number;
    report: ReportModel;
    examForms: ExamFormSummaryModel[] = [];
    treatments: TreatmentSummaryModel[] = [];
    permissions: PermissionsModel;
    consultation: ConsultationSummaryModel;
}

export enum MedicalReportPermissions {
    REPORT_PERMISSION_GENERATE_DOCUMENT = 'REPORT_PERMISSION_GENERATE_DOCUMENT'
}

export const MEDICAL_REPORT_DEFINITION_TYPE_VALUE = 'REPORT_DEFINITION_TYPE_MEDICAL_REPORT';
export const MEDICAL_REPORT_COMPONENT_TYPE_VALUE = 'ACCOUNT_REPORT_COMPONENT_TYPE_MEDICAL_REPORT';

